import { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../services/api/api";
import UpdatePasswordForm from "../../components/Forms/UpdatePasswordForm";
import LinkStatusCard from "../../components/LinkStatus/LinkStatusCard";

function UpdatePassword() {
  // "checking" | "valid" | "expired" | "tooManyRequests" | "error"
  const [linkStatus, setLinkStatus] = useState("checking");

  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);

  const token = query.get("check");
  const isFromApp = query.get("isFromApp")?.toLowerCase() === "true";

  useEffect(() => {
    if (!token) {
      setLinkStatus("expired");
      return;
    }

    axios
      .post("/password/validate", { token })
      .then(() => setLinkStatus("valid"))
      .catch((err) => {
        if (err.response?.status === 404) {
          setLinkStatus("expired");
        } else if (err.response?.status === 429) {
          setLinkStatus("tooManyRequests");
        } else {
          setLinkStatus("error");
        }
      });
  }, [token]);

  if (linkStatus === "checking") {
    return null;
  }

  if (linkStatus === "valid") {
    return (
      <UpdatePasswordForm
        token={token}
        isFromApp={isFromApp}
        onLinkExpired={() => setLinkStatus("expired")}
      />
    );
  }

  return (
    <LinkStatusCard
      linkStatus={linkStatus}
      requestNewLinkPath="/password/reset"
    />
  );
}

export default UpdatePassword;
